import React from 'react';

type Props = {
  color?: string;
};

export const DashboardTabSvg: React.FC<Props> = ({color = '#FF8A71'}) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={50}
      height={24}
      fill='none'
    >
      <path
        fill={color}
        d='M17.669 6.453c0-.985.799-1.784 1.784-1.784h2.675a1.784 1.784 0 1 1 0 3.567h-2.675a1.784 1.784 0 0 1-1.784-1.783Z'
      />
      <path
        fill={color}
        fillRule='evenodd'
        d='M17 6.453A2.453 2.453 0 0 1 19.453 4h2.675a2.453 2.453 0 1 1 0 4.905h-2.675A2.453 2.453 0 0 1 17 6.453Zm2.453-1.115a1.115 1.115 0 0 0 0 2.23h2.675a1.115 1.115 0 0 0 0-2.23h-2.675Z'
        clipRule='evenodd'
      />
      <path
        fill={color}
        d='M17.669 13.142a2.23 2.23 0 0 1 2.23-2.23h1.783a2.23 2.23 0 0 1 2.23 2.23v4.46a2.23 2.23 0 0 1-2.23 2.23H19.9a2.23 2.23 0 0 1-2.23-2.23v-4.46Z'
      />
      <path
        fill={color}
        fillRule='evenodd'
        d='M17 13.142c0-1.6 1.298-2.899 2.899-2.899h1.783c1.601 0 2.9 1.298 2.9 2.899v4.46c0 1.6-1.299 2.898-2.9 2.898H19.9A2.899 2.899 0 0 1 17 17.601v-4.46Zm2.899-1.56a1.56 1.56 0 0 0-1.561 1.56v4.46c0 .861.699 1.56 1.56 1.56h1.784a1.56 1.56 0 0 0 1.561-1.56v-4.46a1.56 1.56 0 0 0-1.56-1.56h-1.784Z'
        clipRule='evenodd'
      />
      <path
        fill={color}
        d='M26.588 6.899a2.23 2.23 0 0 1 2.23-2.23H30.6a2.23 2.23 0 0 1 2.23 2.23v4.46a2.23 2.23 0 0 1-2.23 2.229h-1.783a2.23 2.23 0 0 1-2.23-2.23v-4.46Z'
      />
      <path
        fill={color}
        fillRule='evenodd'
        d='M25.919 6.899C25.919 5.298 27.217 4 28.818 4H30.6C32.202 4 33.5 5.298 33.5 6.899v4.46c0 1.6-1.298 2.898-2.899 2.898h-1.783a2.899 2.899 0 0 1-2.9-2.899v-4.46Zm2.899-1.561a1.56 1.56 0 0 0-1.561 1.56v4.46c0 .862.699 1.56 1.56 1.56h1.784a1.56 1.56 0 0 0 1.561-1.56v-4.46a1.56 1.56 0 0 0-1.56-1.56h-1.784Z'
        clipRule='evenodd'
      />
      <path
        fill={color}
        d='M26.588 18.047c0-.985.798-1.784 1.784-1.784h2.675a1.784 1.784 0 1 1 0 3.568h-2.675a1.784 1.784 0 0 1-1.784-1.784Z'
      />
      <path
        fill={color}
        fillRule='evenodd'
        d='M25.919 18.047a2.453 2.453 0 0 1 2.453-2.452h2.675a2.453 2.453 0 1 1 0 4.905h-2.675a2.453 2.453 0 0 1-2.453-2.453Zm2.453-1.115a1.115 1.115 0 0 0 0 2.23h2.675a1.115 1.115 0 1 0 0-2.23h-2.675Z'
        clipRule='evenodd'
      />
    </svg>
  );
};
